/**
 * BetterError just Error with extra data inside.
 * We can transfer extra information about error up to the stack.
 * @extends Error
 */
class BetterError extends Error {
  // NOTE: потому что сервер шлет корявые ошибки, которые просят поправить копирайтеры
  static getErrorMessage(sourceError) {
    const errorMapping = {
      'No such client': 'Invalid email address',
      'Invalid username/password pair': 'Invalid email/password',
    }

    return errorMapping[sourceError] || sourceError
  }

  constructor(message, customData) {
    message = BetterError.getErrorMessage(message)
    super(message)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BetterError)
    }

    this.data = customData
  }
}

export default BetterError
